import { FC } from "react";

interface ScrollToTopArrowSVGProps {
    className?: string;
}

const ScrollToTopArrowSVG: FC<ScrollToTopArrowSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="20"
            height="32"
            viewBox="0 0 20 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 31V1M10 1L1 12.4286M10 1L19 12.4286"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ScrollToTopArrowSVG;
